import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {PanelSearchContextProvider} from '../../state/panelbank/PanelSearchContextProvider';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {FilteredJSONProvider} from './FilteredJSONProvider';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {FilteredJSONTree} from './FilteredJSONTree';
import {
  SearchableJSONTreeProps,
  SearchableJSONTreePropsProvider,
} from './SearchableJSONTreeProvider';
import {SearchableJSONTreeSettingsProvider} from './SearchableJSONTreeSettings';
import {SearchInput} from './SearchInput';

/*

TODO:
  X searching
  X splitting on slash (CollapsibleJSONTable only splits on first slash. this is stupid.)
  X sorting
  X write tests
  X put this behind a feature flag
  X styling
  X histogram display (and any other special cases in old CollapsibleJSONTable)
  - truncate long keys+values
  - add search highlighting back in (like CollapsibleJSONTable)
  - add viewRawData back in (like CollapsibleJSONTable)
  - create test script that creates arbitrarily nested json for testing

BUGS:
  - if you search 'desc' it matches everything, i think because we're stripping out 'desc' as we traverse (i.e. it still matches descendents, because it hasn't gotten to them yet)

TODO LATER:
  - value search matching. it's working, but only on strings, and it's feature creep (does not exist in CollapsibleJSONTable), so let's hold off for now
  - instead of always stripping the 'desc' key (description field) in config (like CollapsibleJSONTable), actually display it in a tooltip next to the key if it exists
  - add UI controls (e.g. sorting options, allow searching keys and/or values, toggle inclusion of _wandb key, expand/collapse all, etc)
  - add searchHistory. mostly already supported by PanelSearchContextProvider

PERFORMANCE (don't waste your time with these unless we're still seeing perf issues):
  - FilteredJSONTree re-renders the whole tree with each search. stop doing that if perf is an issue.
  - see isDescendentKeySearchMatch for a potentially-faster option (which fails on regexes containing & or ^)

 */

export const SearchableJSONTree = (props: SearchableJSONTreeProps) => {
  return (
    <SearchableJSONTreePropsProvider contextValue={props}>
      <SearchableJSONTreeSettingsProvider>
        <PanelSearchContextProvider>
          <FilteredJSONProvider>
            <SearchableJSONTreeLayout />
          </FilteredJSONProvider>
        </PanelSearchContextProvider>
      </SearchableJSONTreeSettingsProvider>
    </SearchableJSONTreePropsProvider>
  );
};

const SearchableJSONTreeLayout = () => {
  return (
    <Tailwind className="SearchableJSONTree">
      <SearchInput />
      <FilteredJSONTree />
    </Tailwind>
  );
};
